import { BulkEditIcon } from '../atoms/BulkEditIcon';
import { StyledDataGridColumnHeader } from '../atoms/StyledDataGridColumnHeader';

export const BulkEditColumnHeader = ({ headerName, selectedRows, setBulkEditColumn, column }) => (
    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
        <StyledDataGridColumnHeader headerName={headerName} />
        <BulkEditIcon selectedRows={selectedRows} startBulkEdit={() => setBulkEditColumn(column)} />
    </div>
);
